import axios from "axios";

import { msalInstance } from "./index";
import { tokenRequest } from "./config";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_DEPLOY_ENV === "test" ||
    process.env.NODE_ENV === "development"
      ? `https://r4f6h1dfxf.execute-api.us-east-1.amazonaws.com`
      : `https://h72y369jd8.execute-api.us-east-1.amazonaws.com`,
});

api.interceptors.request.use(
  async (config) => {
    const authRequest = {
      ...tokenRequest
    };
    await msalInstance.acquireTokenSilent(authRequest)
      .then(tokenResponse => {
        config.headers["Authorization"] = `Bearer ${tokenResponse.accessToken}`;
      }).catch(error => {
        // No fallback to acquireTokenRedirect - the API call will just fail
        delete config.headers["Authorization"];
      });

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    console.log("error in api call", error);
    if (error.response.status === 403) {
      await msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount()
      });
    }
    return Promise.reject(error);
  }
);

export default api;
